(function () {
  if (typeof window === 'undefined') return;

  var MQ = window.matchMedia('(max-width: 749px)');
  var scrollPadBound = false;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function isMobile() {
    return MQ.matches;
  }

  /* ----- Gallery counter 1/N ----- */
  function initGalleryCounter() {
    var viewer = document.querySelector('.product-pdp .pdp-gallery-viewer') ||
      document.querySelector('.product-pdp media-gallery');
    if (!viewer || viewer.dataset.pdpGalleryReady === '1') return;
    viewer.dataset.pdpGalleryReady = '1';

    var list = viewer.querySelector('.product__media-list');
    if (!list) return;

    var slides = Array.prototype.slice.call(
      list.querySelectorAll('.product__media-item:not([hidden]):not(.is-hidden)')
    );
    if (slides.length < 2) return;

    var counter = viewer.querySelector('.pdp-gallery-counter');
    if (!counter) {
      counter = document.createElement('div');
      counter.className = 'pdp-gallery-counter';
      counter.setAttribute('aria-hidden', 'true');
      viewer.appendChild(counter);
    }

    function activeIndex() {
      var active = list.querySelector(
        '.product__media-item.is-active, .product__media-item[aria-current="true"], .slider__slide[aria-current="true"]'
      );
      if (active) {
        var idx = slides.indexOf(active);
        if (idx >= 0) return idx;
      }
      var scrollLeft = list.scrollLeft || 0;
      var w = list.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(scrollLeft / w)));
    }

    function update() {
      if (!isMobile()) {
        counter.hidden = true;
        return;
      }
      counter.hidden = false;
      counter.textContent = activeIndex() + 1 + '/' + slides.length;
    }

    update();
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(update).observe(list, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'aria-current'],
      });
    }
  }

  /* ----- Short desc: sync fade class with existing toggle ----- */
  function initShortDesc() {
    document.querySelectorAll('[data-pdp-short-desc]').forEach(function (wrap) {
      var toggle = wrap.querySelector('[data-pdp-short-desc-toggle]');
      if (!toggle) return;
      wrap.classList.toggle('is-open', toggle.getAttribute('aria-expanded') === 'true');
    });
  }

  /* ----- Story sections → mobile accordion ----- */
  function initStoryAccordion() {
    var story = document.querySelector('.pdp-story');
    if (!story || story.dataset.pdpAccReady === '1') return;
    story.dataset.pdpAccReady = '1';

    var sections = Array.prototype.slice.call(story.querySelectorAll('.pdp-story__section'));
    if (!sections.length) return;

    function clearDesktop() {
      sections.forEach(function (sec) {
        sec.classList.remove('is-mobile-collapsed', 'is-mobile-open');
        var btn = sec.querySelector('.pdp-story__section-toggle');
        if (btn) btn.hidden = true;
      });
    }

    function ensureToggle(sec) {
      var heading = sec.querySelector('.pdp-story__heading');
      if (!heading) return null;
      var btn = sec.querySelector('.pdp-story__section-toggle');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdp-story__section-toggle';
        var clone = heading.cloneNode(true);
        clone.removeAttribute('id');
        btn.appendChild(clone);
        sec.insertBefore(btn, sec.firstChild);
      }
      return btn;
    }

    function setOpen(sec, open) {
      sec.classList.toggle('is-mobile-open', open);
      sec.classList.toggle('is-mobile-collapsed', !open);
      var btn = sec.querySelector('.pdp-story__section-toggle');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function applyMobile() {
      if (!isMobile()) {
        clearDesktop();
        return;
      }
      sections.forEach(function (sec, index) {
        var btn = ensureToggle(sec);
        if (btn) {
          btn.hidden = false;
          btn.onclick = function () {
            setOpen(sec, !sec.classList.contains('is-mobile-open'));
          };
        }
        /* Overview open by default; Sizes → FAQs (+ Craft) collapsed */
        var openDefault =
          sec.id === 'pdp-overview' || (index === 0 && !document.getElementById('pdp-overview'));
        setOpen(sec, openDefault);
      });
    }

    applyMobile();
    if (typeof MQ.addEventListener === 'function') MQ.addEventListener('change', applyMobile);
    else if (typeof MQ.addListener === 'function') MQ.addListener(applyMobile);

    document.addEventListener(
      'click',
      function (e) {
        if (!isMobile()) return;
        var a = e.target.closest('[data-pdp-page-nav] a[href^="#"]');
        if (!a) return;
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target || !target.classList.contains('pdp-story__section')) return;
        setOpen(target, true);
      },
      true
    );

    window.pdpMobileOpenStory = function (id) {
      var target = document.getElementById(id);
      if (target && target.classList.contains('pdp-story__section')) setOpen(target, true);
    };
  }

  /* ----- Reviews mobile actions (Judge.me) ----- */
  function initReviewsActions() {
    var host = document.getElementById('pdp-reviews') || document.getElementById('judgeme_product_reviews');
    if (!host) {
      var wid = document.querySelector('.jm-review-widget, .jdgm-rev-widg, #judgeme_product_reviews');
      if (wid) host = wid.closest('#pdp-reviews, .shopify-section, .shopify-app-block') || wid;
    }
    if (!host || host.dataset.pdpReviewsReady === '1') return;
    host.dataset.pdpReviewsReady = '1';

    var widget =
      host.querySelector('#judgeme_product_reviews') ||
      host.querySelector('.jm-review-widget') ||
      host.querySelector('.jdgm-rev-widg') ||
      host;

    var mutating = false;

    function markScoreAndCount(avg) {
      if (!avg) return;
      var nodes = avg.querySelectorAll('span, div, p, a, b, strong, em');
      var i;
      var el;
      var t;
      for (i = 0; i < nodes.length; i++) {
        el = nodes[i];
        if (el.classList.contains('pdp-rev-stars')) continue;
        if (el.closest('.jm-star-rating, .jm-stars, .pdp-rev-stars, [class*="star-rating"]')) continue;
        t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t) continue;
        /* Average is X.Y — never mark bare integers like "56" */
        if (/^\d\.\d+$/.test(t)) {
          el.classList.add('pdp-rev-score');
        } else if (/\breviews?\b/i.test(t)) {
          el.classList.add('pdp-rev-count');
        }
      }
      if (!avg.querySelector('.pdp-rev-score')) {
        for (i = 0; i < avg.childNodes.length; i++) {
          var n = avg.childNodes[i];
          var m = n.nodeType === 3 && (n.textContent || '').match(/(\d\.\d+)/);
          if (m) {
            var wrap = document.createElement('span');
            wrap.className = 'pdp-rev-score';
            wrap.textContent = m[1];
            n.textContent = (n.textContent || '').replace(m[1], '');
            avg.insertBefore(wrap, n);
            break;
          }
        }
      }
      if (!avg.querySelector('.jm-star-rating, .pdp-rev-stars, [class*="star-rating"]')) {
        var stars = document.createElement('em');
        stars.className = 'pdp-rev-stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.textContent = '★★★★★';
        var scoreEl = avg.querySelector('.pdp-rev-score');
        var countEl = avg.querySelector('.pdp-rev-count');
        if (countEl) {
          avg.insertBefore(stars, countEl);
        } else if (scoreEl && scoreEl.nextSibling) {
          avg.insertBefore(stars, scoreEl.nextSibling);
        } else if (scoreEl) {
          avg.appendChild(stars);
        } else {
          avg.appendChild(stars);
        }
      }
    }

    function layoutSummary() {
      if (!isMobile() || mutating) return;
      var header = widget.querySelector('.jm-review-widget-header, .jm-review-widget__header');
      if (!header) return;

      var avg =
        header.querySelector('.jm-review-widget-header__average-rating-display') ||
        header.querySelector('.jm-average-rating-display') ||
        header.querySelector('[class*="average-rating"]');
      var hist = header.querySelector('.jm-histogram, [class*="histogram"]');
      if (!avg) return;

      mutating = true;
      try {
        markScoreAndCount(avg);
        if (hist && !header.querySelector('.pdp-rev-sum')) {
          var row = document.createElement('div');
          row.className = 'pdp-rev-sum';
          avg.parentNode.insertBefore(row, avg);
          row.appendChild(avg);
          row.appendChild(hist);
        }
      } finally {
        mutating = false;
      }
    }

    function reviewCountLabel() {
      var txt = (widget.innerText || '').match(/(\d+)\s+reviews?/i);
      return txt ? 'See all ' + txt[1] + ' reviews' : 'See all reviews';
    }

    function compactReviewCards() {
      if (!isMobile() || mutating) return;
      widget.querySelectorAll('.jm-review-item, .jdgm-rev').forEach(function (item) {
        if (item.dataset.pdpCompact === '1') return;
        item.dataset.pdpCompact = '1';

        var content =
          item.querySelector('.jm-review-item__content') ||
          item.querySelector('.jdgm-rev__content') ||
          item;
        var stars =
          item.querySelector('.jm-star-rating') ||
          item.querySelector('.jdgm-rev__rating') ||
          item.querySelector('[class*="star-rating"]');
        var nameEl =
          item.querySelector('.jm-reviewer-info__name') ||
          item.querySelector('.jdgm-rev__author') ||
          item.querySelector('[class*="author"]');
        var name = nameEl ? nameEl.textContent.replace(/\s+/g, ' ').trim() : 'Customer';

        if (stars && !item.querySelector('.pdp-revcard-top')) {
          var top = document.createElement('div');
          top.className = 'pdp-revcard-top';
          var starsWrap = stars.parentElement;
          top.appendChild(stars);
          var meta = document.createElement('span');
          meta.className = 'pdp-revcard-meta';
          meta.textContent = name + ' · verified';
          top.appendChild(meta);
          content.insertBefore(top, content.firstChild);
          /* Empty .jm-cluster left after moving stars still reserves height */
          if (
            starsWrap &&
            starsWrap.classList.contains('jm-cluster') &&
            !starsWrap.querySelector('.jm-star-rating, [class*="star"]')
          ) {
            starsWrap.setAttribute('hidden', '');
            starsWrap.style.setProperty('display', 'none', 'important');
            starsWrap.style.setProperty('height', '0', 'important');
            starsWrap.style.setProperty('min-height', '0', 'important');
            starsWrap.style.setProperty('margin', '0', 'important');
            starsWrap.style.setProperty('padding', '0', 'important');
          }
        }

        var info = item.querySelector('.jm-reviewer-info');
        if (info) info.setAttribute('hidden', '');

        var title =
          item.querySelector('.jm-review-content__title') ||
          item.querySelector('.jdgm-rev__title');
        if (title) title.setAttribute('hidden', '');

        var revContent =
          item.querySelector('.jm-review-content') ||
          item.querySelector('.jdgm-rev__body') ||
          item.querySelector('[class*="review-content"]');
        if (revContent && !revContent.querySelector('.pdp-revcard-quote')) {
          var parts = [];
          revContent.querySelectorAll('p, .jm-text').forEach(function (node) {
            if (node.classList.contains('jm-review-content__title')) return;
            if (node.closest('.jm-review-content__title')) return;
            var t = (node.textContent || '').replace(/\s+/g, ' ').trim();
            if (!t || /^more$/i.test(t) || /^less$/i.test(t)) return;
            parts.push(t);
            node.setAttribute('hidden', '');
          });
          revContent.querySelectorAll('button, a').forEach(function (el) {
            if (/more|less/i.test(el.textContent || '')) el.setAttribute('hidden', '');
          });
          var quoteText = parts.join(' ').replace(/^["“]+|["”]+$/g, '').trim();
          if (quoteText) {
            var quote = document.createElement('p');
            quote.className = 'pdp-revcard-quote';
            quote.textContent = '“' + quoteText + '”';
            revContent.appendChild(quote);

            requestAnimationFrame(function () {
              if (quote.scrollHeight <= quote.clientHeight + 2) return;
              if (revContent.querySelector('.pdp-revcard-more')) return;
              var moreBtn = document.createElement('button');
              moreBtn.type = 'button';
              moreBtn.className = 'pdp-revcard-more';
              moreBtn.textContent = 'Show more';
              moreBtn.addEventListener('click', function () {
                var open = quote.classList.toggle('is-expanded');
                moreBtn.textContent = open ? 'Show less' : 'Show more';
                moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
              });
              revContent.appendChild(moreBtn);
            });
          }
        }
      });
    }

    function ensureActions() {
      if (widget.querySelector('.pdp-reviews-mobile-actions') || mutating) return;
      mutating = true;
      try {
        var actions = document.createElement('div');
        actions.className = 'pdp-reviews-mobile-actions';
        actions.innerHTML =
          '<button type="button" data-pdp-see-all-reviews>' +
          reviewCountLabel() +
          '</button>' +
          '<button type="button" class="is-primary" data-pdp-write-review>Write a review</button>';
        widget.appendChild(actions);

        actions.querySelector('[data-pdp-write-review]').addEventListener('click', function () {
          var writeBtn =
            widget.querySelector('.jm-action-buttons button, .jm-action-buttons a, .jdgm-write-rev-link') ||
            document.querySelector('#judgeme_product_reviews .jm-action-buttons button, .jdgm-write-rev-link');
          if (writeBtn) writeBtn.click();
        });

        actions.querySelector('[data-pdp-see-all-reviews]').addEventListener('click', function () {
          widget.classList.add('is-reviews-expanded');
          host.classList.add('is-reviews-expanded');
          widget.querySelectorAll('.jm-review-item, .jdgm-rev').forEach(function (rev) {
            rev.style.setProperty('display', 'block', 'important');
            var q = rev.querySelector('.pdp-revcard-quote');
            if (q) q.classList.add('is-expanded');
          });
          var more = widget.querySelector('.jm-load-more-pagination button, .jm-button--primary');
          if (more) more.click();
          this.textContent = 'All reviews shown';
        });
      } finally {
        mutating = false;
      }
    }

    layoutSummary();
    compactReviewCards();
    ensureActions();

    if (typeof MutationObserver !== 'undefined') {
      var scheduled = false;
      new MutationObserver(function () {
        if (mutating || scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          layoutSummary();
          compactReviewCards();
          ensureActions();
        });
      }).observe(widget, { childList: true, subtree: true });
    }
  }

  /* ----- Related + recently viewed → native rail ----- */
  function bindRailProgress(track, bar) {
    if (!track || !bar || track.dataset.pdpProgBound === '1') return;
    track.dataset.pdpProgBound = '1';

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = max > 0 ? track.scrollLeft / max : 0;
      bar.style.width = Math.max(18, Math.min(100, 18 + ratio * 82)) + '%';
    }

    update();
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  function ensureRailMeta(root, count) {
    var titleWrap = root.querySelector('.collection__title');
    if (!titleWrap) return;
    var meta = titleWrap.querySelector('.pdp-rail-meta');
    if (!meta) {
      meta = document.createElement('p');
      meta.className = 'pdp-rail-meta';
      titleWrap.appendChild(meta);
    }
    meta.textContent = count + (count === 1 ? ' product' : ' products') + ' · swipe →';
  }

  function ensureRailProg(root, track) {
    var slider = root.querySelector('.related-products__slider') || track.parentElement;
    if (!slider) return;
    var prog = slider.querySelector('.pdp-rail-prog');
    if (!prog) {
      prog = document.createElement('div');
      prog.className = 'pdp-rail-prog';
      prog.setAttribute('aria-hidden', 'true');
      prog.innerHTML = '<i></i>';
      slider.appendChild(prog);
    }
    bindRailProgress(track, prog.querySelector('i'));
  }

  function unslickIfNeeded(track) {
    var $ = window.jQuery;
    if (!$ || !$.fn || typeof $.fn.slick !== 'function') return;
    var $track = $(track);
    if ($track.hasClass('slick-initialized')) {
      try {
        $track.slick('unslick');
      } catch (e) {}
    }
  }

  function initRelatedRails() {
    if (!isMobile()) return;

    document.querySelectorAll('.shopify-section.related-products, .related-products, .recently-viewed').forEach(function (root) {
      if (root.classList.contains('recently-viewed') && root.style.display === 'none') return;

      var track =
        root.querySelector('#recently__product') ||
        root.querySelector('.related-products__track') ||
        root.querySelector('ul.product-grid');
      if (!track) return;

      unslickIfNeeded(track);
      track.classList.add('is-pdp-rail');

      /* Flatten slick leftovers if any */
      track.querySelectorAll('.slick-list, .slick-track').forEach(function (wrap) {
        while (wrap.firstChild) track.appendChild(wrap.firstChild);
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
      });

      var items = Array.prototype.slice.call(track.children).filter(function (el) {
        return el.classList && (el.classList.contains('grid__item') || el.classList.contains('slick-slide'));
      });

      var isRelated =
        !root.classList.contains('recently-viewed') &&
        (!!root.closest('.shopify-section.related-products') ||
          (root.classList.contains('related-products') && !root.classList.contains('recently-viewed')));

      if (isRelated) {
        items.forEach(function (el, i) {
          if (i >= 6) el.setAttribute('hidden', '');
          else el.removeAttribute('hidden');
        });
      }

      var visible = items.filter(function (el) {
        return !el.hasAttribute('hidden') && el.style.display !== 'none';
      }).length;

      if (!visible) {
        if (root.classList.contains('recently-viewed')) root.style.display = 'none';
        return;
      }

      ensureRailMeta(root, isRelated ? Math.min(visible, 6) : visible);
      ensureRailProg(root, track);
    });
  }

  function scheduleRelatedRails() {
    initRelatedRails();
    window.setTimeout(initRelatedRails, 200);
    window.setTimeout(initRelatedRails, 800);
  }

  /* ----- Scroll margin sync with header height ----- */
  function syncScrollPad() {
    if (!isMobile()) return;
    var header = document.querySelector('.section-header');
    var nav = document.querySelector('.section-pdp-page-nav');
    var h = (header ? header.offsetHeight : 0) + (nav ? nav.offsetHeight : 0) + 8;
    if (h > 80) {
      document.documentElement.style.setProperty('--mm-scroll-pad', h + 'px');
    }
  }

  function bindScrollPadOnce() {
    if (scrollPadBound) return;
    scrollPadBound = true;
    window.addEventListener('scroll', syncScrollPad, { passive: true });
    window.addEventListener('resize', syncScrollPad);
  }

  function initAll() {
    initGalleryCounter();
    initShortDesc();
    initStoryAccordion();
    initReviewsActions();
    initRelatedRails();
    scheduleRelatedRails();
    syncScrollPad();
    bindScrollPadOnce();
  }

  onReady(initAll);
  document.addEventListener('recently-viewed:ready', function () {
    if (!isMobile()) return;
    window.setTimeout(scheduleRelatedRails, 0);
  });
  if (MQ.addEventListener) {
    MQ.addEventListener('change', function () {
      if (MQ.matches) scheduleRelatedRails();
    });
  } else if (MQ.addListener) {
    MQ.addListener(function () {
      if (MQ.matches) scheduleRelatedRails();
    });
  }
  document.addEventListener('shopify:section:load', function () {
    var gallery = document.querySelector('.product-pdp .pdp-gallery-viewer, .product-pdp media-gallery');
    if (gallery) delete gallery.dataset.pdpGalleryReady;
    var story = document.querySelector('.pdp-story');
    if (story) delete story.dataset.pdpAccReady;
    var reviews = document.getElementById('pdp-reviews') || document.getElementById('judgeme_product_reviews');
    if (reviews) delete reviews.dataset.pdpReviewsReady;
    initAll();
  });
})();
